<template>
  <div>
    <nav>
      <ul class="pager">
        <li class="previous">
          <router-link :to="{ name: 'client_dashboard', client_id: $route.params.client_id }">
            <span aria-hidden="true">&larr;</span> Client dashboard
          </router-link>
        </li>
      </ul>
    </nav>
    <div v-if="fetching">
      <h1>Spring Review Summary Report</h1>
      <h4>This may take a few minutes</h4>
      <loader></loader>
    </div>
    <div v-else>
      <h1>Key Vet Spring Review {{ model.Misc.season_start_year }} Summary Report</h1>

      <div class="sections">
        <br />
        <div class="form-group">
          <h2 class="text-left alert alert-success">Introduction</h2>
          <textarea rows="5" cols="50" v-model="introductionComment" class="form-control"> </textarea>
        </div>

        <br />
        <client-details :model="model['ClientDetails']" @onRemoveSection="removeSection"> </client-details>
        <hr />

        <mastitis :model="model['Mastitis']" @onRemoveSection="removeSection" ref="mastitis"> </mastitis>
        <hr />

        <review-calving :model="model['ReviewCalving']" @onRemoveSection="removeSection" ref="review_calving">
        </review-calving>
        <hr />

        <review-sick-cows :model="model['ReviewSickCows']" @onRemoveSection="removeSection" ref="review_sick_cows">
        </review-sick-cows>
        <hr />

        <calf-health :model="model['CalfHealth']" @onRemoveSection="removeSection"> </calf-health>
        <hr />

        <down-cow-meta :model="model['DownCowMeta']" @onRemoveSection="removeSection"> </down-cow-meta>
        <hr />

        <trace-elements :model="model['TraceElements']" @onRemoveSection="removeSection" ref="trace_elements">
        </trace-elements>
        <hr />

        <review-reproduction
          :model="model['ReviewReproduction']"
          @onRemoveSection="removeSection"
          ref="review_reproduction"
        >
        </review-reproduction>
        <hr />

        <review-amu :model="model['ReviewAmu']" @onRemoveSection="removeSection" ref="review_amu"> </review-amu>
        <hr />

        <review-nsaids :model="model['ReviewNsaids']" @onRemoveSection="removeSection" ref="review_nsaids">
        </review-nsaids>
        <hr />

        <forecast-lepto :model="model['ForecastLepto']" @onRemoveSection="removeSection"> </forecast-lepto>
        <hr />

        <forecast-scanning :model="model['ForecastScanning']" @onRemoveSection="removeSection"> </forecast-scanning>
        <hr />

        <div class="form-group">
          <h2 class="text-left alert alert-success">Final comments</h2>
          <textarea rows="5" cols="50" v-model="finalComment" class="form-control"> </textarea>
        </div>

        <button v-if="!generatingPDF" class="btn btn-success" v-on:click="generateReport">Generate PDF</button>

        <img
          v-if="generatingPDF"
          src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_API_URL, consultFormService } from '../../_services'
import { SpringSummaryComponents } from '../../components/reports/sr_summary'
import { authHeader, scrollToTop, handleResponse } from '../../_helpers'
import axios from 'axios'

export default {
  name: 'SpringReviewSummaryPage',
  components: {
    ...SpringSummaryComponents,
  },
  data() {
    return {
      model: {},
      clientSelected: false,
      clientId: null,
      season: null,
      search_type: 'name',
      fetching: true,
      generatingPDF: false,
      removedSections: {
        ClientDetails: { removed: false },
        Mastitis: { removed: false },
        ReviewCalving: { removed: false },
        ReviewSickCows: { removed: false },
        CalfHealth: { removed: false },
        DownCowMeta: { removed: false },
        TraceElements: { removed: false },
        ReviewReproduction: { removed: false },
        ReviewAmu: { removed: false },
        ReviewNsaids: { removed: false },
        ForecastLepto: { removed: false },
        ForecastScanning: { removed: false },
      },
      introductionComment: '',
      finalComment: '',
    }
  },
  mounted() {
    scrollToTop()
    this.clientId = this.$route.params.client_id
    this.season = this.$route.params.season
    this.onClientSelected()
  },
  methods: {
    addChartsToModel: function () {
      if (!this.removedSections['TraceElements'].removed) {
        this.model['TraceElements']['CHARTS_b64'] = {}
        if (this.$refs.trace_elements.$refs.serum_mg_chart) {
          this.model['TraceElements']['CHARTS_b64']['serum_mg'] =
            this.$refs.trace_elements.$refs.serum_mg_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.trace_elements.$refs.serum_sse_chart) {
          this.model['TraceElements']['CHARTS_b64']['serum_sse'] =
            this.$refs.trace_elements.$refs.serum_sse_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.trace_elements.$refs.liver_cu_chart) {
          this.model['TraceElements']['CHARTS_b64']['liver_cu'] =
            this.$refs.trace_elements.$refs.liver_cu_chart.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['Mastitis'].removed) {
        this.model['Mastitis']['CHARTS_b64'] = {}
        if (this.$refs.mastitis.$refs.treatments_chart) {
          this.model['Mastitis']['CHARTS_b64']['treatments'] =
            this.$refs.mastitis.$refs.treatments_chart.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['ReviewCalving'].removed) {
        this.model['ReviewCalving']['CHARTS_b64'] = {}
        if (this.$refs.review_calving.$refs.cows_assisted_chart) {
          this.model['ReviewCalving']['CHARTS_b64']['cows_assisted'] =
            this.$refs.review_calving.$refs.cows_assisted_chart.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['ReviewSickCows'].removed) {
        this.model['ReviewSickCows']['CHARTS_b64'] = {}
        if (this.$refs.review_sick_cows.$refs.avg_spend_on_vet_exams) {
          this.model['ReviewSickCows']['CHARTS_b64']['avg_spend_on_vet_exams'] =
            this.$refs.review_sick_cows.$refs.avg_spend_on_vet_exams.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['ReviewReproduction'].removed) {
        this.model['ReviewReproduction']['CHARTS_b64'] = {}
        if (this.$refs.review_reproduction.$refs.metrichecked_chart) {
          this.model['ReviewReproduction']['CHARTS_b64']['metrichecked'] =
            this.$refs.review_reproduction.$refs.metrichecked_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.review_reproduction.$refs.noncycling_chart) {
          this.model['ReviewReproduction']['CHARTS_b64']['noncycling'] =
            this.$refs.review_reproduction.$refs.noncycling_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.review_reproduction.$refs.cuemate_chart) {
          this.model['ReviewReproduction']['CHARTS_b64']['cuemate'] =
            this.$refs.review_reproduction.$refs.cuemate_chart.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['ReviewAmu'].removed) {
        this.model['ReviewAmu']['CHARTS_b64'] = {}
        if (this.$refs.review_amu.$refs.five_years_traffic_chart) {
          this.model['ReviewAmu']['CHARTS_b64']['five_years_traffic'] =
            this.$refs.review_amu.$refs.five_years_traffic_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.review_amu.$refs.period_compare_chart) {
          this.model['ReviewAmu']['CHARTS_b64']['period_compare'] =
            this.$refs.review_amu.$refs.period_compare_chart.$refs.canvas.toDataURL()
        }
      }
      if (!this.removedSections['ReviewNsaids'].removed) {
        this.model['ReviewNsaids']['CHARTS_b64'] = {}
        if (this.$refs.review_nsaids.$refs.annual_nsaids_chart) {
          this.model['ReviewNsaids']['CHARTS_b64']['annual_nsaids'] =
            this.$refs.review_nsaids.$refs.annual_nsaids_chart.$refs.canvas.toDataURL()
        }
        if (this.$refs.review_nsaids.$refs.period_nsaids_chart) {
          this.model['ReviewNsaids']['CHARTS_b64']['period_nsaids'] =
            this.$refs.review_nsaids.$refs.period_nsaids_chart.$refs.canvas.toDataURL()
        }
      }
    },
    generateReport: function () {
      let endpoint = BASE_API_URL + '/reports/sr_summary/' + this.clientId + '/export_pdf/' + this.season

      this.addChartsToModel()
      this.generatingPDF = true

      return axios({
        method: 'POST',
        url: endpoint,
        headers: authHeader(),
        responseType: 'blob',
        data: {
          model: this.model,
          configuration: this.removedSections,
          introduction: this.introductionComment,
          final_comment: this.finalComment,
        },
      })
        .catch(handleResponse)
        .then(
          (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.clientId + '_spring_review_report.pdf') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
            this.generatingPDF = false
          },
          (/* error */) => {
            window.scrollTo(0, 0)

            this.$store.dispatch('alert/error', { message: 'An error occurred. Contact the administrator.' })
            this.generatingPDF = false
          }
        )
    },
    onClientSelected: function () {
      this.clientSelected = true
      this.fetching = true

      consultFormService
        .getSummaryReportSettings({ clientId: this.clientId, consultType: 'spring_review' })
        .then((data) => {
          this.removedSections = data.settings
        })

      // let endpoint = '/clients/'+this.clientId+'/spring_review/'+this.season
      let endpoint = `/clients/${this.clientId}/spring_review/${this.season}`
      consultFormService.getClientConsultData(endpoint).then(
        (data) => {
          this.model = data
          this.fetching = false
        },
        (/* error */) => {
          this.fetching = false
          this.$store.dispatch('alert/error', { message: 'An error occurred. Contact the administrator.' })
        }
      )
    },
    removeSection: function (section, subsection) {
      if (subsection) {
        if (this.removedSections[section][subsection] == undefined) {
          this.$set(this.removedSections[section], subsection, true)
        } else {
          this.$set(this.removedSections[section], subsection, !this.removedSections[section][subsection])
        }
      } else {
        this.removedSections[section]['removed'] = !this.removedSections[section]['removed'] || false
      }
    },
  },
}
</script>

<style>
dd {
  text-align: left;
}
.sections {
  padding-left: 20px;
}
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
.glyphicon-remove {
  color: red;
}
.glyphicon-plus {
  color: #5cb85c;
}
.dl-horizontal dt {
  white-space: normal;
}
.subsection-disabled {
  text-decoration: line-through;
}

div.step-section {
  margin: 50px 5px;
}
</style>
